export const EMAIL_INPUT_PLACEHOLDER = 'email';
export const PASSWORD_INPUT_PLACEHOLDER = 'password';
export const PASSWORD_INPUT = 'password';
export const SINGLE_CHARACTER = 'SINGLE_CHARACTER';

// PATHS
export const BASE_AUTH_PATH = '/auth';
export const BASE_SIGNUP_PATH = `${BASE_AUTH_PATH}/signup`;

export const SIGNUP_PATHS = {
  PERSON_SELECT: `${BASE_SIGNUP_PATH}/person-select`,
  INFO: `${BASE_SIGNUP_PATH}/info`,
  INDIVIDUAL_INFO: `${BASE_SIGNUP_PATH}/idividual-info`,
  VERIFICATION: `${BASE_SIGNUP_PATH}/verification`,
  KEY_GENERATION: `${BASE_SIGNUP_PATH}/key-generation`,
  KEY_GENERATION_RESULT: `${BASE_SIGNUP_PATH}/key-generation-result`,
  CODE: `${BASE_SIGNUP_PATH}/code`,
  DOCS: `${BASE_SIGNUP_PATH}/docs`,
  AGREEMENT: `${BASE_SIGNUP_PATH}/agreement`,
  PASSWORD: `${BASE_SIGNUP_PATH}/set-pass`,
  NEW: `${BASE_SIGNUP_PATH}/new`,
  BASE: BASE_SIGNUP_PATH,
};

// INPUTS
export const FIO_INPUT = 'FIO_INPUT';
export const EMAIL_INPUT = 'EMAIL_INPUT';
export const INN_INPUT = 'INN_INPUT';
export const OGRN_INPUT = 'OGRN_INPUT';
export const COMPANY_NAME_INPUT = 'COMPANY_NAME_INPUT';
export const COMPANY_SHORT_NAME_INPUT = 'COMPANY_SHORT_NAME_INPUT';
export const COMPANY_DOCS_PATH = 'COMPANY_DOCS_PATH';

export const PHONE_NUMBER_PLACEHOLDER = 'Номер телефона';
export const PASSWORD_PLACEHOLDER = 'Пароль';

export const INN_LENGTH = 12;
export const INN_LENGTH_ERROR = `Поле ИНН должно состоять из ${INN_LENGTH} символов`;

export enum BUTTON_TYPES {
  GENERAL = 'general',
  TEXT = 'text',
  SUBMIT = 'submit',
}

export enum ASSETS_STATUS {
  ACTIVE = 'ACTIVE',
  MERGED = 'MERGED',
  REDEEMED = 'REDEEMED',
  REDEEME = 'REDEEME',
  LOCKED = 'LOCKED',
  NOT_ISSUED = 'NOT_ISSUED',
}

export enum REDEEM_STATUS {
  NONE = 'NONE',
  REDEEM_INITIALIZED = 'REDEEM_INITIALIZED',
  REDEEM_PAYMENT_UPLOADED = 'REDEEM_PAYMENT_UPLOADED',
  REDEEM_PAYMENT_SIGNED = 'REDEEM_PAYMENT_SIGNED',
  OWNER_PAYMENT_SIGNED = 'OWNER_PAYMENT_SIGNED',
  COMPLETED = 'COMPLETED',
}

export const ASSETS_STATUS_NAME_MAP = {
  ACTIVE: 'Активный',
  REDEEMED: 'Погашен',
  NOT_ISSUED: 'Требует согласования',
};

export enum ASSETS_TYPES {
  SIMPLE = 'SIMPLE',
  HYBRID = 'HYBRID',
}

export enum ASSET_TOKEN_STATUS {
  ACTIVE = 'ACTIVE',
  MERGED = 'MERGED',
  REDEEMED = 'REDEEMED',
  LOCKED = 'LOCKED',
}

export enum LOANS_STATUS {
  SIGNED = 'SIGNED',
  APPLIED = 'APPLIED',
  CLOSED = 'CLOSED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  REJECTED = 'REJECTED',
}

export enum ACTIONS {
  SALE = 'SALE',
  PURCHASE = 'PURCHASE',
  CREDIT = 'CREDIT',
  HYBRID_ISSUE = 'HYBRID_ISSUE',
  FINANCE_ISSUE = 'FINANCE_ISSUE',
  OPERATOR_ACTIONS = 'OPERATOR_ACTIONS',
}

export enum DOCUMENT_LIST_TYPE {
  DECISION = 'DECISION',
  SIGNED_DECISION = 'SIGNED_DECISION',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PAYMENT_SIGNED = 'PAYMENT_SIGNED',
}

export const LOANS_STATUS_NAME_MAP = {
  SIGNED: 'На согласовании',
  APPLIED: 'Требует погашения',
  CLOSED: 'Погашен',
  DECLINED: 'Отказ',
  EXPIRED: 'Платеж просрочен',
  REJECTED: 'Отменена',
};

// TEXTS
export const AUTH_FOOTER = '© 2022-2026 Платформа «Лайтхаус»';
export const LOGO_TEXT = `Цифровые\nФинансовые активы`;
export const CODE_CONFIRMATION_INFO = `Если вы не получили код, нажмите отправить код\nповторно`;
export const CODE_CONFIRMATION_SECONDS_LEFT = (seconds: number) =>
  `по истечении ${seconds} сек`;
export const RESEND_CODE = 'Отправить код повторно';

// MASKS_FORMATS
export const PHONE_MASK_FORMAT = '+# ### ###-##-##';

export const PUSH_TIMEOUT = 1000 * 5;

export const MAX_COUNT_LAST_TRANSACTION = 10;
export const DEFAULT_COUNT_LAST_TRANSACTION = 5;

// SERVER ERRORS DISPLAYING
export enum PROFILE_INFO_ERROR {
  DUPLICATE_DATA = 'Данная компания уже зарегистрирована',
}

export enum UPLOAD_DOCS_ERROR {
  FORMAT = 'Ошибка загружаемого формата. Допускаются форматы pdf и jpeg',
  SIZE = 'Размер загружаемого файла не может превышать 3 мегабайта',
}

export const USER_STATUSES = {
  NEW: 'NEW',
  PERSONAL_DATA_INPUT: 'PERSONAL_DATA_INPUT',
  ORGANIZATION_DATA_UPLOADING: 'ORGANIZATION_DATA_UPLOADING',
  ACCESSION_AGREEMENT: 'ACCESSION_AGREEMENT',
  PASSWORD_CREATION: 'PASSWORD_CREATION',
  CREDIT_REQUIRED: 'CREDIT_REQUIRED',
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
};

export enum TRANSACTION_TYPE_MAP {
  CREDIT = 'Заём',
  CREDIT_REPAYMENT = 'Погашение займа',
  SALE = 'Продажа',
  PURCHASE = 'Покупка',
  // PURCHASE_TRANSFER = "Перевод купленных ЦФА",
  ISSUE = 'Выпуск',
  ISSUE_PAYMENT = 'Подтверждение выпуска',
  REDEEM = 'Погашение',
  // ADJUSTMENT = "Оплата корректировки",
  // MONETARY_CLAIM_IMPLEMENTATION = "Реализация денежного требования",
  // COMMODITY_CLAIM_IMPLEMENTATION = "Реализация товарного требования",
  EXCHANGE = 'Обмен',
  // JUDICIAL_OPERATION = "Операция в рамках судебного акта",
  // OTHER_OPERATIONS = "Передача другому лицу в рамках иных операций",
}

export const CONST_OPERATION_TYPE = {
  CREDIT: 'CREDIT',
  CREDIT_REPAYMENT: 'CREDIT_REPAYMENT',
  SALE: 'SALE',
  REDEEM: 'REDEEM',
  PURCHASE: 'PURCHASE',
  PURCHASE_TRANSFER: 'PURCHASE_TRANSFER',
  ISSUE: 'ISSUE',
  ISSUE_PAYMENT: 'ISSUE_PAYMENT',
  ADJUSTMENT: 'ADJUSTMENT',
  MONETARY_CLAIM_IMPLEMENTATION: 'MONETARY_CLAIM_IMPLEMENTATION',
  COMMODITY_CLAIM_IMPLEMENTATION: 'COMMODITY_CLAIM_IMPLEMENTATION',
  EXCHANGE: 'EXCHANGE',
  JUDICIAL_OPERATION: 'JUDICIAL_OPERATION',
  OTHER_OPERATIONS: 'OTHER_OPERATIONS',
};
